import { shadcn } from '@clerk/ui/themes';

// The shadcn theme reads the app's CSS variables, so Clerk's UI follows the light/dark mode of the shell.
export const clerkAppearance = { theme: shadcn };
